import script from "./_results-filters.vue?vue&type=script&setup=true&lang=js"
export * from "./_results-filters.vue?vue&type=script&setup=true&lang=js"

import "./_results-filters.vue?vue&type=style&index=0&id=636fe95e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-636fe95e"]])

export default __exports__